module.exports = __webpack_public_path__ + "static/media/icono_antecedentes.0aac5535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icono_antecedentes.png
// module id = 808
// module chunks = 0